import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { getAPIHostURL } from '../../../ClientConfig';

const CanceOTAbutton = ({ deviceId, DeviceID}) => {
	const [loading, setLoading] = useState(false);
	const [status, setStatus] = useState('');
	const [cancelled, setCancelled] = useState(false);
	const id = deviceId || DeviceID;

	useEffect(() => {
		if (!status) return;

		const timeout = setTimeout(() => setStatus(''), 2000);
		return () => clearTimeout(timeout);
	}, [status]);

	const handleCancel = async () => {
		if (!id || loading) return;

		setLoading(true);
		setStatus('');
		try {
			const jsonParams = { DeviceID: id};
			await axios.post(`${getAPIHostURL()}/wclient/cancelOta`, jsonParams);
			setCancelled(true);
			setStatus('OTA cancellation done successfully.');
            // snackbar or notification can be added here to inform the user of success
            // e.g., showSnackbar('OTA cancellation requested.');
            
		} catch (error) {
			setStatus(error.message || 'Failed to cancel OTA.');
		} finally {
			setLoading(false);
		}
	};

	return (
		<div>
			<button
				type="button"
				onClick={handleCancel}
				disabled={!id || loading || cancelled}
				style={{
					padding: '6px 10px',
					border: 'none',
					borderRadius: '6px',
					backgroundColor: cancelled ? '#2e7d32' : loading ? '#78909c' : '#1976d2',
					color: '#fff',
					fontSize: '12px',
					fontWeight: 600,
					whiteSpace: 'nowrap',
					cursor: !id || loading || cancelled ? 'not-allowed' : 'pointer',
					opacity: !id ? 0.6 : 1,
					boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
					transition: 'background-color 0.2s ease'
				}}
			>
				{loading ? 'Cancelling' : cancelled ? ' Cancelled' : 'Cancel OTA'}
			</button>
			{status && (
				<div
					role="alert"
					aria-live="assertive"
					style={{
						position: 'fixed',
						bottom: '16px',
						right: '16px',
						zIndex: 1000,
						maxWidth: 'calc(100vw - 32px)',
						boxSizing: 'border-box',
						marginTop: '6px',
						padding: '8px 10px',
					borderRadius: '4px',
					backgroundColor: '#323232',
					color: '#fff',
						fontSize: '12px',
						overflowWrap: 'anywhere'
					}}
				>
					{status}
				</div>
			)}
		</div>
	);
};

export default CanceOTAbutton;
